import apiWrapper from './apiWrapprer'

const endpoints = {
  getAggregateReportInitialConfig: '/frontend/webMethods/Statistics.asmx/GetAggregateReportInitialConfig',
  getAggregateReportConfig: '/frontend/webMethods/Statistics.asmx/GetAggregateReportConfig',
  getAggregateReportData: '/frontend/webMethods/Statistics.asmx/GetAggregateReportData',
  getAggregateReportMessages: '/frontend/webMethods/Statistics.asmx/GetAggregateReportMessages',
  getAggregateReportMessageDetails: '/frontend/webMethods/Statistics.asmx/GetAggregateReportMessageDetails',
  getAggregateReportLinks: '/frontend/webMethods/Statistics.asmx/GetAggregateReportLinks',
  getAggregateReportStatus: '/frontend/webMethods/Statistics.asmx/GetAggregateReportStatus',
  processAggregateReport: '/frontend/webMethods/Statistics.asmx/ProcessAggregateReport'
}

export const getAggregateReportInitialConfig = (encReportId) => {
  const url = endpoints.getAggregateReportInitialConfig

  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId })
  }).then(extractData)
}

export const getAggregateReportConfig = (encReportId, pwd) => {
  const url = endpoints.getAggregateReportConfig

  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd })
  }).then(extractData)
}

export const getAggregateReportData = (encReportId, pwd) => {
  const url = endpoints.getAggregateReportData

  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd })
  }).then(extractData)
}

export const getAggregateReportMessages = (encReportId, pwd, pageSize, pageNumber) => {
  const url = endpoints.getAggregateReportMessages
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd, pageSize, pageNumber })
  }).then(extractData)
}

export const getAggregateReportLinks = (encReportId, pwd, pageSize, pageNumber) => {
  const url = endpoints.getAggregateReportLinks
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd, pageSize, pageNumber })
  }).then(extractData)
}

export const getAggregateReportMessageDetails = (encReportId, pwd, idMessage) => {
  const url = endpoints.getAggregateReportMessageDetails
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd, idMessage })
  }).then(extractData)
}

export const getAggregateReportStatus = (encReportId, pwd) => {
  const url = endpoints.getAggregateReportStatus
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd })
  }).then(extractData)
}

export const processAggregateReport = (encReportId, pwd) => {
  const url = endpoints.processAggregateReport
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ encReportId, pwd })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
